import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
import { notImplemented, warning, StringUtilities } from '@awayfl/swf-loader';
import { axCoerceString, ObjectEncoding, AMF3, transformASValueToJS, transformJSValueToAS } from '@awayfl/avm2';
import { ByteArray } from '../utils/ByteArray';
export var AWAY_SO_VERSION = 3;
export var AWAY_SO_MAGIC = 'AWAY';
export var AWAY_SO_HEADER_SIZE = AWAY_SO_MAGIC.length + 2; // magic, version, coma
var _sharedObjectStorage;
var VirtualStorage = /** @class */ (function () {
    function VirtualStorage() {
        this._values = {};
        this._realStorage = null;
    }
    VirtualStorage.prototype.getItem = function (key) {
        if (this._realStorage) {
            this._values[key] = this._realStorage.getItem(key);
        }
        return this._values[key];
    };
    VirtualStorage.prototype.setItem = function (key, value) {
        if (this._realStorage) {
            this._realStorage.setItem(key, value);
        }
        this._values[key] = value;
    };
    VirtualStorage.prototype.removeItem = function (key) {
        if (this._realStorage) {
            this._realStorage.removeItem(key);
        }
        delete this._values[key];
    };
    return VirtualStorage;
}());
export function getSharedObjectStorage() {
    if (!_sharedObjectStorage) {
        _sharedObjectStorage = new VirtualStorage();
        if (typeof Storage !== 'undefined') {
            try {
                _sharedObjectStorage._realStorage = window.localStorage;
            }
            catch (e) {
                console.warn('[Shared Storage] ', e);
            }
        }
    }
    return _sharedObjectStorage;
}
var SharedObjectDebug = /** @class */ (function () {
    function SharedObjectDebug() {
    }
    SharedObjectDebug.decodedData = function () {
        if (!USED_SEC) {
            throw 'Can\'t decode without security context';
        }
        var store = getSharedObjectStorage();
        var raw = {};
        var dec = {};
        for (var key in store._values) {
            var d = store._values[key];
            if (d !== null) {
                raw[key] = SharedObject.tryDecodeData(store._values[key]).data;
                dec[key] = transformASValueToJS(USED_SEC, raw[key], true);
            }
            else {
                raw[key] = dec[key] = null;
            }
        }
        this._lastDecodedData = dec;
        this._lastRawData = raw;
        return dec;
    };
    SharedObjectDebug.encodeAndApplyData = function () {
        if (!this._lastRawData) {
            throw 'Need call decode before encode for detecting model';
        }
        var newRaw = {};
        for (var key in this._lastRawData) {
            if (typeof this._lastDecodedData[key] === undefined) {
                newRaw[key] = this._lastRawData[key];
                continue;
            }
            newRaw[key] = transformJSValueToAS(USED_SEC, this._lastDecodedData[key], true);
        }
        var so = getSharedObjectStorage();
        for (var key in newRaw) {
            if (newRaw[key] !== null) {
                so.setItem(key, SharedObject.tryEncodeData(newRaw[key]));
            }
        }
        return newRaw;
    };
    SharedObjectDebug._lastRawData = null;
    SharedObjectDebug._lastDecodedData = null;
    return SharedObjectDebug;
}());
export { SharedObjectDebug };
//@ts-ignore
window._AWAY_DEBUG_STORAGE = SharedObjectDebug;
window.addEventListener('unload', function () {
    SharedObject.closeAll();
});
window.addEventListener('blur', function () {
    SharedObject.flushAll();
});
var USED_SEC = undefined;
var SharedObject = /** @class */ (function (_super) {
    __extends(SharedObject, _super);
    function SharedObject() {
        var _this = _super.call(this) || this;
        _this.awaySOVersion = 1; // legacy
        return _this;
    }
    Object.defineProperty(SharedObject, "defaultObjectEncoding", {
        get: function () {
            notImplemented('public flash.net.SharedObject::static defaultObjectEncoding');
            return;
        },
        set: function (version /*uint*/) {
            notImplemented('public flash.net.SharedObject::static defaultObjectEncoding');
            return;
        },
        enumerable: false,
        configurable: true
    });
    SharedObject.deleteAll = function (url) {
        notImplemented('public flash.net.SharedObject::static deleteAll');
        return;
    };
    SharedObject.getDiskUsage = function (url) {
        notImplemented('public flash.net.SharedObject::static getDiskUsage');
        return 0;
    };
    /* internal */ SharedObject.tryDecodeData = function (data) {
        var version = 1;
        if (data.indexOf(AWAY_SO_MAGIC) > -1) {
            version = +data[AWAY_SO_MAGIC.length];
            data = data.substring(AWAY_SO_HEADER_SIZE);
        }
        var bytes = StringUtilities.decodeRestrictedBase64ToBytes(data);
        var serializedData = new ByteArray(bytes.length);
        serializedData.sec = this.sec || USED_SEC;
        serializedData.setArrayBuffer(bytes.buffer);
        return {
            data: AMF3.read(serializedData),
            version: version
        };
    };
    /* internal */ SharedObject.tryEncodeData = function (data) {
        var serializedData = new ByteArray();
        serializedData.sec = this.sec || USED_SEC;
        AMF3.write(serializedData, data);
        var bytes = new Uint8Array(serializedData.arraybytes, 0, serializedData.length);
        return StringUtilities.base64EncodeBytes(bytes);
    };
    SharedObject.getLocal = function (name, localPath, secure) {
        USED_SEC = this.sec;
        name = axCoerceString(name);
        localPath = axCoerceString(localPath);
        secure = !!secure;
        var path = (localPath || '') + '/' + name;
        if (SharedObject._sharedObjects[path]) {
            return SharedObject._sharedObjects[path];
        }
        var encodedData = getSharedObjectStorage().getItem(path);
        var encoding = this._defaultObjectEncoding;
        var data;
        var version = AWAY_SO_VERSION;
        if (encodedData) {
            try {
                var res = SharedObject.tryDecodeData(encodedData);
                data = res.data;
                version = res.version;
            }
            catch (e) {
                warning('Error encountered while decoding LocalStorage entry. Resetting data.');
            }
            if (!data || typeof data !== 'object') {
                data = this.sec.createObject();
            }
        }
        else {
            data = this.sec.createObject();
        }
        var so = new this.sec.flash.net.SharedObject();
        so._path = path;
        so._objectEncoding = encoding;
        so._data = data;
        so.awaySOVersion = version;
        SharedObject._sharedObjects[path] = so;
        return so;
    };
    SharedObject.getRemote = function (name, remotePath, persistence, secure) {
        return new this.sec.flash.net.SharedObject();
    };
    SharedObject.closeAll = function () {
        for (var key in SharedObject._sharedObjects) {
            if (SharedObject._sharedObjects[key]) {
                SharedObject._sharedObjects[key].close();
            }
        }
    };
    SharedObject.flushAll = function () {
        for (var key in SharedObject._sharedObjects) {
            if (SharedObject._sharedObjects[key]) {
                SharedObject._sharedObjects[key].flush();
            }
        }
    };
    SharedObject.prototype.flush = function (minDiskSpace) {
        if (minDiskSpace === void 0) { minDiskSpace = 0; }
        // Check if the object is empty. If it is, don't create a stored object if one doesn't exist.
        var isEmpty = true;
        for (var key in this._data) {
            if (this._data.hasOwnProperty(key)) {
                isEmpty = false;
                break;
            }
        }
        if (isEmpty && !getSharedObjectStorage().getItem(this._path)) {
            return;
        }
        USED_SEC = this.sec;
        var encoded = AWAY_SO_MAGIC +
            AWAY_SO_VERSION.toFixed(0) + ',' +
            SharedObject.tryEncodeData(this._data);
        getSharedObjectStorage().setItem(this._path, encoded);
    };
    Object.defineProperty(SharedObject.prototype, "data", {
        get: function () {
            return this._data;
        },
        set: function (object) {
            this._data = object;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SharedObject.prototype, "objectEncoding", {
        get: function () {
            notImplemented('public flash.net.SharedObject::get objectEncoding');
            return;
        },
        set: function (version /*uint*/) {
            notImplemented('public flash.net.SharedObject::set objectEncoding');
            return;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SharedObject.prototype, "client", {
        get: function () {
            notImplemented('public flash.net.SharedObject::get client');
            return;
            // return this._client;
        },
        set: function (object) {
            notImplemented('public flash.net.SharedObject::set client');
            return;
            // this._client = object;
        },
        enumerable: false,
        configurable: true
    });
    SharedObject.prototype.setDirty = function (propertyName) {
        notImplemented('public flash.net.SharedObject::setDirty');
        return;
    };
    SharedObject.prototype.connect = function (myConnection, params) {
        if (params === void 0) { params = null; }
        notImplemented('public flash.net.SharedObject::connect');
        return;
    };
    SharedObject.prototype.send = function () {
        notImplemented('public flash.net.SharedObject::send');
        return;
    };
    /**
     * Closed and flushed SO
     * @see https://help.adobe.com/en_US/FlashPlatform/reference/actionscript/3/flash/net/SharedObject.html#close()
     */
    SharedObject.prototype.close = function () {
        // should run flush when close is requested
        this.flush();
        delete SharedObject._sharedObjects[this._path];
    };
    /**
     * Clear object
     * @see https://help.adobe.com/en_US/FlashPlatform/reference/actionscript/3/flash/net/SharedObject.html#clear()
     */
    SharedObject.prototype.clear = function () {
        this._data = this.sec.createObject();
        // should run flush to overwrite a data to empty, but we only remove key
        // this is look like simmilar
        getSharedObjectStorage().removeItem(this._path);
        delete SharedObject._sharedObjects[this._path];
    };
    Object.defineProperty(SharedObject.prototype, "size", {
        get: function () {
            var _a;
            return ((_a = getSharedObjectStorage().getItem(this._path)) === null || _a === void 0 ? void 0 : _a.length) || 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SharedObject.prototype, "fps", {
        set: function (updatesPerSecond) {
            notImplemented('public flash.net.SharedObject::set fps');
            return;
        },
        enumerable: false,
        configurable: true
    });
    SharedObject.prototype.setProperty = function (propertyName, value) {
        if (value === void 0) { value = null; }
        notImplemented('public flash.net.SharedObject::setProperty');
        return;
    };
    SharedObject._sharedObjects = {};
    SharedObject._defaultObjectEncoding = ObjectEncoding.DEFAULT;
    return SharedObject;
}(ASObject));
export { SharedObject };
